import React, { useState } from 'react';
import { Tabs, Tab, TextField, Button, Snackbar } from '@mui/material';
import { useAuth } from './AuthContext';
import { Link } from 'react-router-dom';

const { TabPane } = Tabs;

const Signup = () => {
    const { signup } = useAuth();
    const [activeRole, setActiveRole] = useState('recruiter');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [organization, setOrganization] = useState('');
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const onFinish = async (event) => {
        event.preventDefault();
        try {
            const values = { email, password, name, phone, organization, role: activeRole };
            await signup(values);
            setSnackbarMessage('Signup successful! Please check your email to verify your account.');
            setSnackbarOpen(true);
        } catch (error) {
            setSnackbarMessage('Signup failed: ' + (error.response?.data?.message || error.message));
            setSnackbarOpen(true);
        }
    };

    const onTabChange = (event, newValue) => {
        setActiveRole(newValue);
        setEmail('');
        setPassword('');
        setName('');
        setPhone('');
        setOrganization('');
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    return (
        <div style={{ maxWidth: '400px', margin: '0 auto', padding: '20px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
            <div style={{ textAlign: 'center', marginBottom: '20px' }}>
                <img src="https://hireveda.com/content/images/size/w1000/2023/05/HireVeda-6.png" alt="HireVeda Logo" style={{ width: '100px' }} />
            </div>
            <Tabs value={activeRole} onChange={onTabChange} centered>
                <Tab label="Recruiter" value="recruiter" />
                <Tab label="Candidate" value="candidate" />
            </Tabs>
            <form onSubmit={onFinish} noValidate>
                <TextField
                    label="Email"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <TextField
                    label="Password"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <TextField
                    label="Full Name"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <TextField
                    label="Phone Number"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    required
                    inputProps={{ maxLength: 10 }}
                />
                <TextField
                    label="Organization"
                    variant="outlined"
                    fullWidth
                    margin="normal"
                    value={organization}
                    onChange={(e) => setOrganization(e.target.value)}
                    required
                />
                <Button type="submit" variant="contained" color="primary" fullWidth>
                    Sign Up
                </Button>
            </form>
            <Link to="/login">
                <Button variant="text" color="primary" fullWidth style={{ marginTop: '10px' }}>
                    Already have an account? Log in
                </Button>
            </Link>
            <Snackbar
                open={snackbarOpen}
                onClose={handleSnackbarClose}
                message={snackbarMessage}
                autoHideDuration={6000}
            />
        </div>
    );
};

export default Signup;
